import humanize from 'humanize';
window.humanize = humanize;
